/** ERR-01..05 : 401, 403, 404, 500 et erreur de route. */
import { Link, isRouteErrorResponse, useRouteError } from 'react-router';
import { Icon } from '@myron/design-system';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Ban, FileQuestion, LogIn, ServerCrash } from 'lucide-react';
import { useSession } from '../../shared/auth/session';

function PageErreur({ icone, titre, children, action }: { icone: LucideIcon; titre: string; children: ReactNode; action: ReactNode }) {
  return (
    <div className="my-conteneur my-section">
      <div className="my-vide">
        <Icon icon={icone} />
        <h1 className="my-titre-2" style={{ color: 'var(--texte-principal)' }}>{titre}</h1>
        <p>{children}</p>
        {action}
      </div>
    </div>
  );
}

function Retour() {
  const { session } = useSession();
  const vers = session ? (session.utilisateur.type === 'INTERNE' ? '/admin' : '/pro') : '/';
  return <Link to={vers} className="my-btn my-btn--primaire">Revenir à l’accueil</Link>;
}

export function Page403() {
  return (
    <PageErreur icone={Ban} titre="Accès refusé" action={<Retour />}>Vous n’avez pas les droits nécessaires pour afficher cette page. Si vous pensez que c’est une erreur, contactez votre administrateur.</PageErreur>
  );
}
export function Page404() {
  return (
    <PageErreur icone={FileQuestion} titre="Page introuvable" action={<Retour />}>Cette page n’existe pas ou n’est plus disponible.</PageErreur>
  );
}
export function Page401() {
  return (
    <PageErreur icone={LogIn} titre="Connexion requise" action={<Link to="/connexion" className="my-btn my-btn--primaire">Se connecter</Link>}>Connectez-vous pour accéder à cette page.</PageErreur>
  );
}
export function Page500() {
  return (
    <PageErreur icone={ServerCrash} titre="Une erreur est survenue" action={<Retour />}>Réessayez dans quelques instants. Si le problème persiste, contactez le support.</PageErreur>
  );
}
export function ErreurRoute() {
  const e = useRouteError();
  if (isRouteErrorResponse(e) && e.status === 404) return <Page404 />;
  console.error(e);
  return <Page500 />;
}
